module.exports = __webpack_public_path__ + "logo.5af3793bbd02c3b40f85.png";


//////////////////
// WEBPACK FOOTER
// /revet-web/src/assets/images/logo.png
// module id = ../../../../../src/assets/images/logo.png
// module chunks = styles